import React, { useLayoutEffect } from 'react';
import HeaderV3 from '../HeaderV3/headerV3.component';
import FooterSection from '../FooterSection/footersection.component';
import './DocPage.css';

/**
 * Shared layout for simple written-content pages (careers, legal policies, etc.).
 * Renders the standard header, a styled article column, and the footer.
 *
 * Props:
 *  - eyebrow:  small label above the title (optional)
 *  - title:    page heading
 *  - updated:  "Last updated …" line (optional)
 *  - children: the page body
 */
function DocPage({ eyebrow, title, updated, children }) {
  useLayoutEffect(() => {
    document.body.style.backgroundColor = '#131022';
    return () => { document.body.style.backgroundColor = ''; };
  }, []);

  return (
    <main className="page-wrapper dark-mode">
      <HeaderV3 />
      <article className="doc-page">
        <div className="doc-page__inner">
          <header className="doc-page__head">
            {eyebrow && <span className="doc-page__eyebrow">{eyebrow}</span>}
            <h1 className="doc-page__title">{title}</h1>
            {updated && <p className="doc-page__updated">{updated}</p>}
          </header>
          <div className="doc-page__body">
            {children}
          </div>
        </div>
      </article>
      <FooterSection />
    </main>
  );
}

export default DocPage;
